import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import api from "../../services/api";
import {
  Card,
  CardHeader,
  CardContent,
  // CardActions,
  Divider,
  Grid,
  Button,
  // TextField
} from "@material-ui/core";
import {
  MuiPickersUtilsProvider,
  // DatePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns"; // choose your lib
import { ptBR } from "date-fns/locale";
import Axios from "axios";

import socketIOClient from "socket.io-client";
const ENDPOINT = "http://186.205.67.216:4000";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },

  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    fontWeight: "500",
    fontFamily: "Nunito",
  },
  liquidoValue: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    fontWeight: "bold",
    fontFamily: "Nunito",
  },
}));

function retUltimoDia(year, month) {
  var ultimoDia = new Date(year, month, 0).getDate();
  return ultimoDia;
}

const ContraCheque = () => {
  const classes = useStyles();
  const [selectedDate, handleDateChange] = useState(new Date());
  const [click, setClick] = useState(0);
  const [mes, setMes] = React.useState("01");
  const [ano, setAno] = React.useState("2020");
  const [userInformation, setUserInformation] = React.useState([]);
  const [userInformativo, setUserInformativo] = React.useState([]);
  const [response, setResponse] = useState("");
  const [loading, setLoading] = useState(false);
 

  const fetchDataInformation = async () => {
    setUserInformation([]);
    const result = await api.post("colaborador", {
      cpf: localStorage.getItem("@CPF"),
    });
    setUserInformation(result.data);
    console.log(result.data);
  };

  useEffect(() => {
    fetchDataInformation();
  }, []);

  const fetchUsers = async () => {
    setUserInformativo([]);
    const data = new Date(selectedDate),
      mes = (data.getMonth() + 1).toString().padStart(2, "0"), //+1 pois no getMonth Janeiro começa com zero.
      ano = data.getFullYear();
    setMes(mes);
    setAno(ano);

    const result = await Axios.post("https://nodedeploy.veigadiniz.com.br/contracheque/informativo", {
      DtInicial: ano + "/" + mes + "/01",
      DtFinal: ano + "/" + mes + "/" + retUltimoDia(ano, mes),
      IdFuncionario: userInformation.IdFuncionario,
      TblRegistro: userInformation.tabelaReg,
    });
    setUserInformativo(result.data);
    
    console.log(result.data);
    setLoading(true);
  };

  useEffect(() => {
    fetchUsers();
  }, [click]);

  const userInformativoRender = userInformativo.filter((elementos) => {
    return elementos.cdchamada !== "917";
  });

  const pgto = userInformativo.reduce((total, elemento) => {
    if (elemento.TpEvento === "A" && elemento.cdchamada !== "917")
      return (total += elemento.VlEvento);
    else return total;
  }, 0);

  const desc = userInformativo.reduce((total, elemento) => {
    if (elemento.TpEvento === "D")
      return (total += elemento.VlEvento);
    else return total;
  }, 0);

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item lg={12} xs={12}>
          <Card>
            <CardHeader
              subheader="Veja aqui o detalhe do seu salario"
              title="Contra Cheque"
            />
            <Divider />
            <CardContent>
              <Grid container spacing={3} mr-auto>
                <Grid item md={6} xs={12}>
                  <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disableToolbar
                      variant="dialog"
                      format="MM/yyyy"
                      margin="normal"
                      id="date-picker-inline"
                      label="informe a competência"
                      value={selectedDate}
                      onChange={handleDateChange}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </MuiPickersUtilsProvider>

                  <Button
                    color="primary"
                    variant="contained"
                    onClick={() => setClick(click + 1)}
                  >
                    CONSULTAR
                  </Button>
                </Grid>
                <Grid container mr-auto md={12} xs={12}>
                  <Grid item xs={12} sm={12}>
                    <Paper
                      square={true}
                      elevation={0}
                      variant="outlined"
                      className={classes.paper}
                    >
                      DEMONSTRATIVO DE PAGAMENTO DE SALÁRIO -{response}
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Paper
                      square={true}
                      elevation={0}
                      variant="outlined"
                      className={classes.paper}
                    >
                      {userInformation.Empresa} - {userInformation.CNPJ} -{" "}
                      {userInformation.Endereco}
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Paper
                      square={true}
                      elevation={0}
                      variant="outlined"
                      className={classes.paper}
                    >
                      {userInformation.cdchamada} -{" "}
                      {userInformation.NmFuncionario}
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={1}>
                    <Paper
                      square={true}
                      elevation={0}
                      variant="outlined"
                      className={classes.paper}
                    >
                      CÓD.
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Paper
                      square={true}
                      elevation={0}
                      variant="outlined"
                      className={classes.paper}
                    >
                      DESCRIÇÃO
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <Paper
                      square={true}
                      elevation={0}
                      variant="outlined"
                      className={classes.paper}
                    >
                      REFERÊNCIA
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Paper
                      square={true}
                      elevation={0}
                      variant="outlined"
                      className={classes.paper}
                    >
                      VENCIMENTOS
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Paper
                      square={true}
                      elevation={0}
                      variant="outlined"
                      className={classes.paper}
                    >
                      DESCONTOS
                    </Paper>
                  </Grid>
                  {userInformativoRender.map((inf) => (
                    <>
                      <Grid item xs={12} sm={1}>
                        <Paper
                          square={true}
                          elevation={0}
                          variant="outlined"
                          className={classes.paper}
                        >
                          {inf.cdchamada}
                        </Paper>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Paper
                          square={true}
                          elevation={0}
                          variant="outlined"
                          className={classes.paper}
                        >
                          {inf.NmEvento}
                        </Paper>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <Paper
                          square={true}
                          elevation={0}
                          variant="outlined"
                          className={classes.paper}
                        >
                          {inf.QtEvento}
                        </Paper>
                      </Grid>
                      <Grid item xs={12} sm={2}>
                        <Paper
                          square={true}
                          elevation={0}
                          variant="outlined"
                          className={classes.paper}
                        >
                          {inf.TpEvento == "A" ? inf.VlEvento.toFixed(2) : "0"}
                        </Paper>
                      </Grid>
                      <Grid item xs={12} sm={2}>
                        <Paper
                          square={true}
                          elevation={0}
                          variant="outlined"
                          className={classes.paper}
                        >
                          {inf.TpEvento === "D" ? inf.VlEvento.toFixed(2) : "0"}
                        </Paper>
                      </Grid>
                    </>
                  ))}
                  <Grid item xs={12} sm={1}>
                    <Paper
                      square={true}
                      elevation={0}
                      className={classes.paper}
                    ></Paper>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Paper
                      square={true}
                      elevation={0}
                      className={classes.paper}
                    ></Paper>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <Paper
                      square={true}
                      elevation={0}
                      className={classes.paper}
                    ></Paper>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Paper
                      square={true}
                      elevation={0}
                      variant="outlined"
                      className={classes.paper}
                    >
                      {pgto.toFixed(2)}
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Paper
                      square={true}
                      elevation={0}
                      variant="outlined"
                      className={classes.paper}
                    >
                      {desc.toFixed(2)}
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <Paper
                      square={true}
                      elevation={0}
                      className={classes.paper}
                    ></Paper>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Paper
                      square={true}
                      elevation={0}
                      variant="outlined"
                      className={classes.liquidoValue}
                    >
                      VALOR LIQUIDO
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Paper
                      square={true}
                      elevation={0}
                      variant="outlined"
                      className={classes.liquidoValue}
                    >
                      {(pgto - desc).toFixed(2)}
                    </Paper>
                  </Grid>

                  {/* {userInformativoRender.map((inf) =>
                    inf.StTipoEvento === "I" ? (
                      <Grid item xs={12} sm={6}>
                        <Paper
                          square={true}
                          elevation={0}
                          variant="outlined"
                          className={classes.liquidoValue}
                        > 
                          {inf.VlBaseEvento}
                          {inf.AlINSS}
                        </Paper>
                      </Grid>
                    ) : (
                      <></>
                    ) 
                  )}

                  {userInformativoRender.map((inf) =>
                    inf.StTipoEvento === "I" ? (
                      <Grid item xs={12} sm={6}>
                        <Paper
                          square={true}
                          elevation={0}
                          variant="outlined"
                          className={classes.liquidoValue}
                        > 
                        {inf.VlBaseEventoBruto}
                          {inf.VlBaseEvento}
                          {inf.AlINSS}
                        </Paper>
                      </Grid>
                    ) : (
                      <></>
                    ) 
                  )} */}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default ContraCheque;
